<template>
  <div class="card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <form ref="form" class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Fecha </label>

                <el-date-picker
                  v-model="formData.date"
                  v-validate="modelValidations.date"
                  align="center"
                  :editable="false"
                  format="dd-MM-yyyy"
                  name="date"
                  :picker-options="{ disabledDate: disabledDate }"
                  placeholder="Fecha"
                  suffix-icon="fas fa-calendar-alt"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <small v-show="date.invalid" class="text-danger">
                  {{ getError('date') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Descripción </label>

                <el-input
                  v-model="formData.detail"
                  v-validate="modelValidations.detail"
                  name="detail"
                  placeholder="Descripción"
                  type="string"
                >
                </el-input>

                <small v-show="detail.invalid" class="text-danger">
                  {{ getError('detail') }}
                </small>
              </div>
            </div>

            <server-error :server-errors="serverErrors"></server-error>

            <div v-if="editMode" class="col-sm-12 text-right">
              <base-button native-type="submit" type="success"> Guardar </base-button>
              <base-button type="danger" @click="cancel"> Cancelar </base-button>
            </div>

            <div v-else class="col-md-12 text-right">
              <base-button native-type="submit" type="primary"> Agregar </base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui';
import { mapFields } from 'vee-validate';
import ServerError from '../../../components/ServerError';
import CampaignDatesBus from '../../../events/buses/campaign-dates.event';

export default {
  components: {
    [DatePicker.name]: DatePicker,
    ServerError,
  },

  props: {
    title: {
      type: String,
      default: 'Agregar nueva fecha límite',
    },

    campaign: {
      type: Object,
      required: true,
    },

    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      editMode: false,
      validated: false,
      formData: {
        date: null,
        detail: null,
        campaign: this.campaign.id,
      },

      modelValidations: {
        date: {
          required: true,
          // date_format: 'yyyy-MM-dd',
          // date_between: [new Date().toJSON().slice(0, 10), this.getMaxLimit()],
          // excluded: this.getExcludedDates,
        },

        detail: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['date', 'detail']),
  },

  created() {
    CampaignDatesBus.$on('campaign-dates-on-edit', this.onEdit);
  },

  beforeDestroy() {
    CampaignDatesBus.$off('campaign-dates-on-edit', this.onEdit);
  },

  methods: {
    disabledDate(date) {
      return date < new Date();
    },

    onEdit(date) {
      this.clean();
      this.editMode = true;
      this.formData.date = date.date;
      this.formData.detail = date.detail;
      this.formData.campaign = this.campaign.id;
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((valid) => {
        if (valid) {
          this.$emit('save', this.formData);
        }
      });
    },

    cancel() {
      this.$emit('cancel');
    },

    reset() {
      this.$refs.form.reset();
      this.clean();
      this.editMode = false;
    },

    clean() {
      this.formData.date = null;
      this.formData.detail = null;
      this.errors.clear();
      this.$validator.reset();
    },

    getError(name) {
      return this.errors.first(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--datetime,
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
